import { ChangeDetectionStrategy, Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { ActivatedRoute } from '@angular/router';
import { ServicesType } from '../../shared/types/services-type';
import { environment } from '../../../environments/environment';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { LnPrimaryButtonComponent } from '@components/butons/ln-primary-button/ln-primary-button.component';
import { MenuActions } from '../../shared/states/menu_actions';
import { LnChevronRightSvgIconComponent } from '@components/svg-icons/ln-chevron-right-svg-icon/ln-chevron-right-svg-icon.component';
import { LnArrowBackSvgIconComponent } from '@components/svg-icons/ln-arrow-back-svg-icon/ln-arrow-back-svg-icon.component';

@Component({
  selector: 'ln-service-details',
  imports: [
    LnPagesArmorComponent,
    TranslocoPipe,
    LnImageFrameComponent,
    LnPrimaryButtonComponent,
    LnChevronRightSvgIconComponent,
    LnArrowBackSvgIconComponent,
  ],
  templateUrl: './service-details.component.html',
  styleUrl: './service-details.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDetailsComponent implements OnInit {
  // private readonly TAG = 'ServiceDetailsComponent';
  private routes = inject(ActivatedRoute);
  protected serviceName: WritableSignal<string | undefined> = signal(undefined);
  protected serviceNameQuestion: WritableSignal<string | undefined> = signal(undefined);
  protected serviceAnswerP1: WritableSignal<string | undefined> = signal(undefined);
  protected serviceAnswerP2: WritableSignal<string | undefined> = signal(undefined);
  protected serviceAnswerP3: WritableSignal<string | undefined> = signal(undefined);
  protected serviceAnswerP4: WritableSignal<string | undefined> = signal(undefined);
  protected imagePath: WritableSignal<string | undefined> = signal(undefined);
  private _showBottomImages: WritableSignal<boolean> = signal(false);
  protected showBottomImages = this._showBottomImages.asReadonly();
  menuAction = inject(MenuActions);
  private baseUrl: string = environment.GOOGLE_STORAGE_URL + '/imagenes/';
  protected imagePathServicesDesign: string = this.baseUrl + environment.banners.SERVICES_DESIGN;
  protected imagePathServicesManagement: string = this.baseUrl + environment.banners.SERVICES_MANAGEMENT;
  protected designsImagesList: string[] = [
    this.baseUrl + environment.banners.SERVICES_DESIGN1,
    this.baseUrl + environment.banners.SERVICES_DESIGN2,
    this.baseUrl + environment.banners.SERVICES_DESIGN3,
    this.baseUrl + environment.banners.SERVICES_DESIGN4,
    this.baseUrl + environment.banners.SERVICES_DESIGN5,
    this.baseUrl + environment.banners.SERVICES_DESIGN6,
    this.baseUrl + environment.banners.SERVICES_DESIGN7,
  ];
  ngOnInit(): void {
    this.getQueryParams();
  }

  getQueryParams(): void {
    this.routes.queryParams.subscribe(params => {
      const serviceType: ServicesType = params['serviceType'];
      if (serviceType) {
        if (serviceType === 'propertyManagement') {
          this.imagePath.set(this.imagePathServicesManagement);
          this.serviceName.set('labels.propertyManagement');
          this.serviceNameQuestion.set('labels.propertyManagementQuestion');
          this.serviceAnswerP1.set('labels.propertyManagementAnswerP1');
          this.serviceAnswerP2.set('labels.propertyManagementAnswerP2');
          this.serviceAnswerP3.set('labels.propertyManagementAnswerP3');
          this.serviceAnswerP4.set('labels.propertyManagementAnswerP4');
        } else {
          this.imagePath.set(this.imagePathServicesDesign);
          this.serviceName.set('labels.interiorDesign');
          this.serviceNameQuestion.set('labels.interiorDesignQuestion');
          this.serviceAnswerP1.set('labels.interiorDesignAnswerP1');
          this.serviceAnswerP2.set('labels.interiorDesignAnswerP2');
          this.serviceAnswerP3.set('labels.interiorDesignAnswerP3');
          this.serviceAnswerP4.set('labels.interiorDesignAnswerP4');
          this._showBottomImages.set(true);
        }
      }
    });
  }

  navigateToContactPage(): void {
    this.menuAction.navigateToContactPage();
  }

  navigateBack(): void {
    this.menuAction.navigateBack();
  }
}
